import { render } from "./MaterialListItemDeleteFormModal.vue?vue&type=template&id=5085b652&lang=pug"
import script from "./MaterialListItemDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./MaterialListItemDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script